var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWoocommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#7F54B3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.5c.2-.5.6-.7 1.1-.7.6 0 1 .3 1.1.8.2.6.4 1.7.7 3.3l1-2.5c.3-.6.6-.9 1-.9.6 0 1 .4 1.1 1.2.3 1.4.6 2.6.7 3.5.2-1.7.4-3 .6-3.9.1-.5.4-.7.9-.7.3 0 .6.1.8.3.2.2.3.5.3.7 0 .2-.1.4-.1.6-.3 1.7-.6 3.4-.9 5.2-.1.6-.4 1-.9 1-.6 0-1-.5-1.2-1.5-.3-1.7-.6-2.9-.7-3.6-.2.7-.6 1.8-1 3-.4 1.4-.8 2-1.3 2-.6 0-1-.6-1.2-1.7-.4-1.7-.8-3.3-1.1-4.9 0-.4 0-.6.2-.8z",
    fill: "#FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11.5c-.4 0-.8.2-1.1.6-.3.4-.4.9-.4 1.5 0 .3 0 .5.1.8.1.3.2.5.4.7.2.2.5.3.9.3.4 0 .8-.2 1.1-.6.3-.4.4-.9.4-1.5 0-.3 0-.5-.1-.8-.1-.3-.2-.5-.4-.7-.2-.2-.5-.3-.9-.3zm-.1 1c.1 0 .2 0 .3.1.1.1.1.2.1.4 0 .3-.1.6-.2.9-.1.2-.2.4-.4.4-.1 0-.2 0-.3-.1-.1-.1-.1-.2-.1-.4 0-.3.1-.6.2-.9.1-.3.2-.4.4-.4z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoocommerce);
export default __webpack_public_path__ + "static/media/woocommerce.a821f61091e8947a9c292cfa3b1734a6.svg";
export { ForwardRef as ReactComponent };